module.exports = __webpack_public_path__ + "img/gygl.d2fa19cf.svg";